/**
 * Sort campaigns by sort_index (if set), then by created_at
 *
 * Sort order:
 * 1. Campaigns with sort_index come first (sorted by sort_index ascending)
 * 2. Campaigns without sort_index come after (sorted by created_at descending - newest first)
 *
 * @param campaigns - Array of campaigns to sort
 * @returns Sorted array of campaigns
 *
 * @example
 * ```tsx
 * const sortedCampaigns = sortCampaignsBySortIndexAndCreatedAt(campaigns);
 * ```
 */
export function sortCampaignsBySortIndexAndCreatedAt<
  T extends { sort_index: number | null; created_at: string },
>(campaigns: T[]): T[] {
  return [...campaigns].sort((a, b) => {
    // Both have sort_index: sort by sort_index ascending
    if (a.sort_index !== null && b.sort_index !== null) {
      return a.sort_index - b.sort_index;
    }
    // Only a has sort_index: a comes first
    if (a.sort_index !== null && b.sort_index === null) {
      return -1;
    }
    // Only b has sort_index: b comes first
    if (a.sort_index === null && b.sort_index !== null) {
      return 1;
    }
    // Both have no sort_index: sort by created_at descending (newest first)
    const dateA = new Date(a.created_at || 0).getTime();
    const dateB = new Date(b.created_at || 0).getTime();
    return dateB - dateA;
  });
}
